const MAP = {
  in_area:        { label: "In Area",         cls: "bg-sky-100 text-sky-800 border-sky-200" },
  exited:         { label: "Keluar",          cls: "bg-slate-100 text-slate-700 border-slate-200" },
  draft:          { label: "Draft",           cls: "bg-slate-100 text-slate-600 border-slate-200" },
  pending_approval: { label: "Menunggu Approve", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  approved:       { label: "Disetujui",       cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  rejected:       { label: "Ditolak",         cls: "bg-red-100 text-red-800 border-red-200" },
  arrived:        { label: "Datang",          cls: "bg-amber-100 text-amber-800 border-amber-200" },
  weighed_in:     { label: "Timbang Masuk",   cls: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  weighed_out:    { label: "Timbang Keluar",  cls: "bg-purple-100 text-purple-800 border-purple-200" },
  unloading:      { label: "Bongkar",         cls: "bg-cyan-100 text-cyan-800 border-cyan-200" },
  loading:        { label: "Loading",         cls: "bg-cyan-100 text-cyan-800 border-cyan-200" },
  scheduled:      { label: "Terjadwal",       cls: "bg-blue-100 text-blue-800 border-blue-200" },
  gate_out:       { label: "Gate Out",        cls: "bg-slate-100 text-slate-700 border-slate-200" },
  closed:         { label: "Selesai",         cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  exception:      { label: "Exception",       cls: "bg-red-100 text-red-800 border-red-200" },
  normal:         { label: "Normal",          cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  warning:        { label: "Warning",         cls: "bg-amber-100 text-amber-800 border-amber-200" },
  critical:       { label: "Kritis",          cls: "bg-red-100 text-red-800 border-red-200" },
};

export default function StatusBadge({ status }) {
  const conf = MAP[status] || { label: status || "-", cls: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-semibold rounded-full border ${conf.cls}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {conf.label}
    </span>
  );
}
